@if (type == 'circle') {
  <button
    (click)="onClick()"
    [attr.aria-label]="ariaLabel"
    [class]="class"
    [color]="color"
    [style]="'height: 24px; width: 24px;'"
    class="black-outline"
    mat-mini-fab
    >
    @if (text) {
      {{ text }}
    }
    @if (svgIcon) {
      <mat-icon [svgIcon]="svgIcon"></mat-icon>
    }
  </button>
}

@if (type == 'rounded') {
  <button
    (click)="onClick()"
    [attr.aria-label]="ariaLabel"
    [class]="class"
    [color]="color"
    class="rounded text-large-700 black-outline"
    mat-raised-button>
    <ng-content></ng-content>
    @if (text) {
      {{ text }}
    }
    @if (svgIcon) {
      <mat-icon [svgIcon]="svgIcon"></mat-icon>
    }
  </button>
}
